<div class="relative rounded-sm p-10 flex flex-content-center" style="width: 80vw">
  <div class="absolute top-1 right-1">
    <button mat-button (click)="close()">
      <fa-icon [icon]="faClose" />
    </button>
  </div>

  <div class="w-full">
    <app-article-search-bar class="w-full" (onSelected)="close()" />
  </div>
</div>
